import styled from 'styled-components';

export const AboutPage = styled.div`
  display: flex;
  height: auto;
  padding: 6% 5%;
  justify-content: space-between;
  align-items: start;
  flex-wrap: wrap;
  gap: 90px;
`

export const AboutStarch = styled.div`
  max-width: 650px;

  h2 {
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--first-color);
    word-wrap: break-word;
  }

  p {
    font-size: 17px;
    margin-top: 20px;
    text-align: justify;
  }

  @media screen and (max-width: 1050px) {
    text-align: center;
  }

`

export const Differential = styled.div`
  h2 {
    font-size: 2.3rem;
    font-weight: 500;
    color: var(--first-color);
    margin-bottom: 10px;
    word-wrap: break-word;
    
    @media screen and (max-width: 1050px){
      text-align: center;
    }
  }
`

export const DifferentialCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;

  @media screen and (max-width: 500px) {
    flex-direction: column
  }
`

export const DifferentialCardsSingle = styled.div`
  text-align: center;
  
  img {
    width: 130px;
  }

  font-weight: 100;
  color: var(--first-color);
  font-size: .98rem;
  
`

export const Photos = styled.div`
  padding: 6% 9%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  background: var(--tenth-color);

  h2 {
    font-size: 2.3rem;
    text-align: center;
    font-weight: 500;
    color: var(--first-color);
    word-wrap: break-word;
  }

  @media screen and (max-width: 1050px) {
    text-align: center;
  }
`

export const PhotoStarch = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  h4 {
    text-align: center;
    font-weight: 400;
    color: var(--first-color);
    font-size: .93rem;
  }
  @media screen and (max-width: 1050px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
`

export const Card = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 1rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 15px 30px rgba(0,0,0,0.2);
  }

  img {
    width: 320px;
    height: 30rem;
    object-fit: cover;
    border-radius: 1rem;
    display: block;
  }

  &::after {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0);
    transition: background 0.3s ease;
  }

  &:hover::after {
    background: rgba(14, 14, 14, 0.986);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease;
    color: #fff;
    width: 2rem;
    height: 2rem;
  }

  &:hover svg {
    opacity: 1;
  }
`;

export const PhotoStarchSingle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  h4 {
    font-size: 17px;
  }

`

export const BoxImageStarch = styled.div`
  width: 300px;
  height: 400px;
  border-radius: 10px;
`

export const VideoStarch = styled.div`
  
`

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 1rem;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 80vw;
  max-height: 80vh;

  img {
    display: block; 
    width: 80vw;           
    height: auto;       
    max-height: 80vh;   
    object-fit: cover;
    border-radius: 0.5rem;
  }

  button {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: rgba(0,0,0,0.5);
    border: none;
    border-radius: 50%;
    color: #fff;
    padding: 0.5rem;
    cursor: pointer;

    &:hover {
      background: rgba(0,0,0,0.7);
    }

    svg {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;